import apiService from './apiService';
import apiServiceNew from './apiService.new';

export default (function () {
	var versionReviewPath = '/versionReview';
	var parseOptions = {
		'datetimes': ['CreateDate', 'ModifyDate']
	};
	var parseOptionsCamelCased = {
		'datetimes': ['createDate', 'modifyDate']
	};

	// Get version review items by status
	function fetch(status, search, filters, limit, offset, sortDirection, sortIndex) {
		var url = versionReviewPath;
		var params = $.extend({}, filters, {
			status: status,
			sortDirection: sortDirection,
			sortIndex: parseInt(sortIndex) + 1
		});

		if (limit !== undefined && offset !== undefined) {
			params.limit = limit;
			params.offset = offset;
		}
		if (search) {
			url += '/search';
			params.search = search;
		}
		if (params) {
			url += apiService.paramsToQuery(params);
		}
		return apiService.get(url)
			.then(function(data) {
				var res = data.items;

				// parse data
				if (res instanceof Array) {
					for (let i = 0; i < res.length; i++) {
						apiService.parse(res[i], parseOptions);
					}
				}
				return data;
			});
	}

	// Get one version review by id
	function get(id) {
		var url = versionReviewPath + '/' + id;

		return apiService.get(url)
			.then(function(data) {
				apiService.parse(data, parseOptionsCamelCased);
				return data;
			});
	}

	function statuses(mediaId) {
		var url = versionReviewPath + '/' + mediaId + '/statuses';

		return apiService.get(url)
			.then(function(data) {
				return data;
			});
	}

	function shared(mediaId, version, token) {
		var url = versionReviewPath + '/shared' +
			apiService.paramsToQuery({
				mediaId: mediaId,
				version: version,
				token: token
			});

		return apiService.get(url)
			.then(function(data) {
				apiService.parse(data);
				return data;
			});
	}

	// PUT an update
	function update(object) {
		return apiService.put(JSON.stringify(object), versionReviewPath);
	}

	const getVersionReviewPathByMediaAndVersion = (mediaID, version) => `${versionReviewPath}/media/${mediaID}/version/${version}`;

	function post({mediaID, version, partnerIds}) {
		const versionReviewPath = getVersionReviewPathByMediaAndVersion(mediaID, version);

		return apiServiceNew.post(versionReviewPath, partnerIds);
	}

	function getByMediaIdAndVersion(mediaID, version) {
		const versionReviewPath = getVersionReviewPathByMediaAndVersion(mediaID, version);

		return apiServiceNew.get(versionReviewPath).then(res => res.data);
	}

	return {
		fetch,
		get,
		update,
		shared,
		statuses,
		post,
		getByMediaIdAndVersion
	};
})();